const ComicListDataset = ["comic1.png", "comic2.png", "comic3.png", "comic4.png", "comic5.png", "comic6.png", 
                "comic7.png"]
        
               

export default ComicListDataset;